import { Table, TableBody } from "@mui/material";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import { useTranslation } from "react-i18next";
import IconMessage, { IconMessageIcon } from "./IconMessage";
import { tbodyStyle } from "../constants";

const Loading = () => {
    const { t } = useTranslation();
    return (
        <Table>
            <TableBody
                style={tbodyStyle}>
                <TableRow style={tbodyStyle}>
                    <TableCell colSpan={20} padding="none"
                        style={{
                            height:'calc(100vh - 512px)',
                            borderBottom: "none",
                            width: "100vw"
                        }}>
                        <IconMessage
                            title={t("components.iconMessage.loading.title")}
                            icon={IconMessageIcon.LOADING}
                            subtitle={t("components.iconMessage.loading.subtitle")} />
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    )
};

export default Loading;
